<script setup>
import {InputText} from "primevue";
import FloatLabel from "primevue/floatlabel";

const props = defineProps({
  state: {
    type: String,
  }
})
const shopState = props.state ? props.state : ''
</script>

<template>
  <div class="col-span-12">
    <FloatLabel variant="on">
      <InputText id="shopState" :value="shopState" autocomplete="off" readonly
                 class="!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700 lg:max-w-24 p-filled"
                 disabled
      />
      <label for="shopState" class="!bg-slate-900 !text-slate-500">Shop State</label>
    </FloatLabel>
  </div>
</template>

<style scoped lang="scss">

</style>